/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetRoleExtended,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Fleet Role List
 */
export const fleetRoles = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<FleetRoleExtended[]>(
      {url: `/fleets/${fleetSlug}/roles`, method: 'GET', signal
    },
      );
    }




export const getFleetRolesQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'roles'
    ] as const;
    }


export const getFleetRolesQueryOptions = <TData = Awaited<ReturnType<typeof fleetRoles>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetRoles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetRolesQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetRoles>>> = ({ signal }) => fleetRoles(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetRoles>>, TError, TData>
}

export type FleetRolesQueryResult = NonNullable<Awaited<ReturnType<typeof fleetRoles>>>
export type FleetRolesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Role List
 */

export function useFleetRoles<TData = Awaited<ReturnType<typeof fleetRoles>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetRolesQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






